module.exports = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            "res/sounds/btn_click"
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/back.jpg",

            "res/roulette/ball.png",
            "res/roulette/ball_shadow.png",
            "res/roulette/rul.png",
            "res/roulette/rul_00.png",
            "res/roulette/rul_00_blink.png",
            "res/roulette/rul_00_shadow.png",
            "res/roulette/rul_blink.png",

            "res/fishki/1.png",
            "res/fishki/5.png",
            "res/fishki/10.png",
            "res/fishki/25.png",
            "res/fishki/50.png",
            "res/fishki/100.png",
            "res/fishki/500.png",
            "res/fishki/1000.png",

            "res/buttons/balance_tab.png",
            "res/buttons/fiski_away_cursor.png",
            "res/buttons/fiski_away_of.png",
            "res/buttons/fiski_away_on.png",
            "res/buttons/input_balance_cursor.png",
            "res/buttons/input_balance_of.png",
            "res/buttons/input_balance_on.png",
            "res/buttons/reload_cursor.png",
            "res/buttons/reload_of.png",
            "res/buttons/reload_on.png",
            "res/buttons/rur_of.png",
            "res/buttons/rur_on.png",
            "res/buttons/take_money_cursor.png",
            "res/buttons/take_money_of.png",
            "res/buttons/take_money_on.png",

            "res/left_part/best_players.png",
            "res/left_part/bronze.png",
            "res/left_part/silver.png",
            "res/left_part/hot_dig.png",
            "res/left_part/cold_dig.png",
            "res/left_part/coefficient.png",
            "res/left_part/razdelitel.png",

            "res/fishka_chosen/fishka_chosen_000.png",
            "res/fishka_chosen/fishka_chosen_001.png",
            "res/fishka_chosen/fishka_chosen_002.png",
            "res/fishka_chosen/fishka_chosen_003.png",
            "res/fishka_chosen/fishka_chosen_004.png",
            "res/fishka_chosen/fishka_chosen_005.png",
            "res/fishka_chosen/fishka_chosen_006.png",
            "res/fishka_chosen/fishka_chosen_007.png",
            "res/fishka_chosen/fishka_chosen_008.png",
            "res/fishka_chosen/fishka_chosen_009.png",
            "res/fishka_chosen/fishka_chosen_010.png",
            "res/fishka_chosen/fishka_chosen_011.png",
            "res/fishka_chosen/fishka_chosen_012.png",
            "res/fishka_chosen/fishka_chosen_013.png",
            "res/fishka_chosen/fishka_chosen_014.png",
            "res/fishka_chosen/fishka_chosen_015.png",
            "res/fishka_chosen/fishka_chosen_016.png",
            "res/fishka_chosen/fishka_chosen_017.png",
            "res/fishka_chosen/fishka_chosen_018.png",
            "res/fishka_chosen/fishka_chosen_019.png",

            "res/bets/color.png",
            "res/bets/dozen.png",
            "res/bets/half.png",
            "res/bets/number.png",
            "res/bets/row.png",
            "res/bets/zero.png",

            "res/fonts/font_credits.xml"
        ]
};



//////////////////
// WEBPACK FOOTER
// ./res/resources.js
// module id = 84
// module chunks = 0